import List from '@/components/common/List';
import ParamRenderer from '@/components/nodes/settings/parameter/ParamRenderer';
import { Configuration, EventHandler as EventMetaHandler } from '@/types/metadata/metadata';
import { Card } from '@mui/material';
import { FC } from 'react';

type EventHandlerViewProps = {
  nodeId: number;
  parentId: number;
  metaEventHandler: EventMetaHandler;
  data: {
    [key: string]: unknown;
  };
  onChange: (...args: [string, unknown][]) => void;
};

const EventHandlerView: FC<EventHandlerViewProps> = (props) => {
  return (
    <Card variant='outlined' sx={{ p: 1, overflow: 'unset' }}>
      <List
        subheader={props.metaEventHandler.label}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1
        }}
      >
        {props.metaEventHandler.args.map((arg, index) => {
          return (
            <ParamRenderer
              key={`EventParam.node[${props.nodeId}].index[${index}]`}
              configuration={
                {
                  ...arg,
                  event_name: props.metaEventHandler.name
                } as Configuration
              }
              onChange={props.onChange}
              nodeId={props.nodeId}
              parentId={props.parentId}
              initialValue={props.data}
            />
          );
        })}
      </List>
    </Card>
  );
};

export default EventHandlerView;
